export type CallExceptionStatusKey =
  | 'profile.callExceptionBlocked'
  | 'profile.callsFromContactAllow'
  | 'profile.callsFromContactBlock';

export function callExceptionStatusKey(exception: {
  call_allowed: boolean;
  blocked_by_owner: boolean;
}): CallExceptionStatusKey {
  if (exception.blocked_by_owner) return 'profile.callExceptionBlocked';
  return exception.call_allowed
    ? 'profile.callsFromContactAllow'
    : 'profile.callsFromContactBlock';
}

export function messageExceptionStatusKey(exception: {
  message_allowed: boolean;
  blocked_by_owner: boolean;
}): CallExceptionStatusKey {
  if (exception.blocked_by_owner) return 'profile.callExceptionBlocked';
  return exception.message_allowed
    ? 'profile.callsFromContactAllow'
    : 'profile.callsFromContactBlock';
}
